<div class='header-container'>
  <div class="flex items-center">
    <mat-form-field class='filter-form-field'>
      <mat-label>{{labelText}}</mat-label>
      <input #inputField matInput type='text'
             [formControl]='inputFormControl'
             [attr.data-qa]="qaAttr || 'qa-input'"
             (input)='onInputValueChanged($event)' />
    </mat-form-field>
    <ng-container *ngIf="matTooltip">
      <mat-icon [matTooltip]=matTooltip class="info-icon">help_outline</mat-icon>
    </ng-container>
  </div>
  <div class='header-spacer'></div>
  <div *ngIf="showButton">
    <ng-content></ng-content>
    <button [routerLink]="navigateTo" [color]="buttonColor" mat-raised-button
            (click)="onClick()">
      <mat-icon>{{iconName}}</mat-icon>
      {{buttonText}}
    </button>
  </div>
</div>
